import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ThemeProvider } from "@mui/material";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Subscription } from "rxjs";
import { Chanels } from "../chanels";
import { EntityService } from "../entity/entity.service";
import { theme } from "../react-theme";
import { SignalsService } from "../signals/signals.service";
import { Guid } from "../system/guid";
import { ServiceBusService } from "../system/service-bus.service";
import "../react-components/i18n";
import CurrentTempPage from "./components/CurrentTemp";

const containerElementName = "myReactComponentContainer";

@Component({
  selector: "app-current-temp-react-component",
  template: `<span #${containerElementName}></span>`,
  encapsulation: ViewEncapsulation.None,
})
export class CurrentTempComponent implements OnChanges, OnDestroy, AfterViewInit {
  @ViewChild(containerElementName, { static: true }) containerRef: ElementRef;

  siteId: Guid;

  @Input()
  public entityId: string;

  public isLoadingEntities = true;

  private userSubscription: Subscription;

  private user: any;

  constructor(
    private bus: ServiceBusService,
    private entityService: EntityService,
    private signalsService: SignalsService,
  ) { }

  ngOnInit() {
    this.userSubscription = this.bus
      .chanelObservable(Chanels.USER_CHANEL)
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
  }

  private render() {
    console.log(this.entityId)
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <CurrentTempContext.Provider
          value={{
            user: this.user,
            entityService: this.entityService,
            signalsService: this.signalsService,
          }}
        >
          {this.entityId && <CurrentTempPage
            entityId={this.entityId}
          />}
        </CurrentTempContext.Provider>
      </ThemeProvider>,
      this.containerRef.nativeElement
    );
  }
}

type ICurrentTempContext = {
  user: any;
  entityService: EntityService;
  signalsService: SignalsService;
};

export const CurrentTempContext = React.createContext<ICurrentTempContext>(undefined);
